import React, {Fragment, useContext, useEffect, useState} from "react";
import CardContainer from "../../../components/CardContainer";
import Card from "../../../components/Card";
import {Link} from "react-router-dom";
import {LoaderContext} from "../../../context/LoaderContext";
import axios from "axios";
import ModalConfirm from "../../../components/ModalConfirm";
import NsDataTable from "../../../components/tabelle/NsDataTable";

function ListRegistriVeicoli() {

    const [loadingData, setLoadingData] = useState(true);
    const [data, setData] = useState([]);
    const [registroSel, setRegistroSel] = useState(null);
    const [show, setShow] = useState(false);

    const {startChiamata, endChiamata} = useContext(LoaderContext);

    function getRegistriVeicoli() {
        startChiamata()
        axios.get(process.env.REACT_APP_API_ENDPOINT + "/api/rfi/veicolo/registro/").then((response) => {
            setData(response.data.data);
            setLoadingData(false);
            endChiamata()
        });
    }

    useEffect(() => {
        if (loadingData === true) {
            getRegistriVeicoli()
        }
    }, []);

    const openModalDel = (utente) => {
        setRegistroSel(utente)
        setShow(true);
    }

    return (
        <CardContainer>
            <Card
                icon={'fas fa-folder'}
                title={'Registri di Veicoli'}
                getBottoniDx={() =>
                    <Link to="/upd-registro-veic" className={"btn btn-card"}>
                        <i className="fas fa-plus-circle"/> Aggiungi
                    </Link>
            }
            >
                <ModalConfirm
                    show={show}
                    handleClose={() => setShow(false)}
                    handleOk={() => {
                        setShow(false);
                        startChiamata()
                        axios.delete(process.env.REACT_APP_API_ENDPOINT + "/api/rfi/veicolo/registro/" + registroSel.id_registro).then((response) => {
                            setData(response.data.data);
                            endChiamata()
                        });
                    }}
                    testo={"Sicuro di voler eliminare il Registro di Veicoli: " + (registroSel && (registroSel.id_registro)) + "?"}/>
                {
                    loadingData ? (
                        <p>Caricamento in corso...</p>
                    ) : (
                        <NsDataTable
                            data={data}
                            columns={[
                                {
                                    name: 'Codice Registro',
                                    selector: row => row.id_registro,
                                    sortable: true,
                                },
                                {
                                    name: 'Descrizione Registro',
                                    selector: row => row.descrizione,
                                    sortable: true,
                                },
                                {
                                    name: 'Suffisso',
                                    selector: row => row.suffisso,
                                    sortable: true,
                                },
                                {
                                    name: 'Ordinamento',
                                    selector: row => row.sort,
                                    sortable: true,
                                },
                                {
                                    name: 'RFI / Abarth',
                                    selector: row => row.quale == '5' ?
                                        <span className={"rfi-etichetta rfi-etichetta--arancione"}>Abarth</span>
                                        : <span className={"rfi-etichetta rfi-etichetta--blu"}>RFI</span>,
                                    sortable: true,
                                },
                                {
                                    name: '',
                                    selector: row => <Fragment>
                                        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
                                            <div className="btn-group" role="group">
                                                <button id="btnGroupDrop1" type="button" className="btn btn-dark dropdown-toggle"
                                                        data-bs-toggle="dropdown" aria-expanded="false">
                                                    <i className="fa-solid fa-bars"></i>
                                                </button>
                                                <ul className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                                    <li>
                                                        <Link to={"/upd-registro-veic/" + row.id_registro}
                                                              className="dropdown-item"
                                                              data-toggle="tooltip" title="Modifica">
                                                            <i className="fas fa-pen"/> Modifica
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <button className="dropdown-item"
                                                                data-toggle="tooltip" title="Elimina" onClick={() => {
                                                            openModalDel(row)
                                                        }}>
                                                            <i className="fas fa-trash"/> Elimina
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </Fragment>,
                                    sortable: false,
                                    right: true,
                                }
                            ]}
                            addPagination={true}
                            funzioneFiltro={(item, filtro) => {
                                return (item.id_registro && item.id_registro.toLowerCase().includes(filtro.toLowerCase()))
                                    || (item.suffisso && item.suffisso.toLowerCase().includes(filtro.toLowerCase()))
                                    || (item.quale == '5' && 'abarth'.includes(filtro.toLowerCase()))
                                    || (item.quale == '3' && 'rfi'.includes(filtro.toLowerCase()))
                            }}
                        >
                        </NsDataTable>
                    )}
            </Card>
        </CardContainer>
    );
}

export default ListRegistriVeicoli;
